// 브라우저 Sentry — 빌드 때 박힌 VITE_SENTRY_DSN 이 있을 때만 켠다(오류만 · 트레이싱·리플레이 없음) · 태그 service=browser.

import { scrubBreadcrumb, scrubEvent } from "@buildpy/core/lib/monitoring-scrub";
import * as Sentry from "@sentry/react";

import { setErrorReporter, shouldReport } from "./monitoring";

// DSN 이 비었거나 op:// 그대로면(op run 없이 빌드) 켜지 않는다 — 화면은 그대로 돈다.
export const browserDsnOf = (env: ImportMetaEnv): string | null => {
  const dsn = env.VITE_SENTRY_DSN?.trim();
  return dsn && !dsn.startsWith("op://") ? dsn : null;
};

export const initBrowserMonitoring = (env: ImportMetaEnv = import.meta.env): boolean => {
  const dsn = browserDsnOf(env);
  if (!dsn) return false;
  const release = env.VITE_SENTRY_RELEASE?.trim();
  Sentry.init({
    dsn,
    environment: env.MODE,
    ...(release ? { release } : {}),
    sendDefaultPii: false,
    // 전역 처리기(잡히지 않은 오류·거부)로 들어온 이동·4xx 도 같은 기준으로 거르고, 보낼 것은 주소 토큰·머리글을 지운다(Worker 와 같은 지우개).
    beforeSend: (event, hint) => (shouldReport(hint.originalException) ? scrubEvent(event) : null),
    beforeBreadcrumb: (breadcrumb) => scrubBreadcrumb(breadcrumb),
    initialScope: { tags: { service: "browser" } },
  });
  setErrorReporter((error) => Sentry.captureException(error));
  return true;
};
